import { render, staticRenderFns } from "./SetProjectmapping.vue?vue&type=template&id=616de28a"
import script from "./SetProjectmapping.vue?vue&type=script&lang=js"
export * from "./SetProjectmapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports